import { RiCheckFill } from "@remixicon/react";
import classNames from "classnames";
import React, {
    ReactElement, ReactNode,
} from "react";
import { Dropdown, DropdownItemProps } from "react-bootstrap";
import { LoggingHandler } from "../../../contexts/logging/LoggingContext";
import { IconSize, IconVariant } from "../icon/Icon";

export interface ItemProps extends DropdownItemProps {
    isActive?: boolean;
    className?: string;
    isChecked?: boolean;
    postFixItem?: ReactNode;
    prefixIcon?: ReactNode;
    target?: string;
    iconSize?: IconSize;
    iconVariant?: IconVariant;
    metricPath?: string[];
}

const Item = React.forwardRef((
    args: ItemProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        isActive,
        className,
        isChecked,
        children,
        postFixItem,
        prefixIcon,
        iconSize,
        metricPath,
        iconVariant,
        onClick,
        ...rest
    } = args;

    const clickHandler = metricPath ? LoggingHandler.instance.wrapMetric(metricPath, onClick) : onClick;

    return (
        <Dropdown.Item ref={ref} onClick={clickHandler} className={classNames(className, { active: isActive })} {...rest}>
            {prefixIcon && (
                <span className={classNames(
                    iconVariant ? `icon-${iconVariant}` : "dropdown-item-prefix-icon",
                    iconSize ? `dropdown-item-prefix-icon-${iconSize}` : "",
                )}
                >
                    {prefixIcon}
                </span>
            )}
            {children && (
                <div className="dropdown-item-content">
                    {children}
                </div>
            )}

            {isChecked && <span><RiCheckFill /></span>}
            {postFixItem}
        </Dropdown.Item>

    );
});

Item.defaultProps = {
    className: "",
    isActive: false,
    postFixItem: undefined,
    prefixIcon: undefined,
    iconSize: "medium",
    target: undefined,
};

export default Item;
